var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7475 4.00043C5.5575 4.00043 5.3675 3.93043 5.2175 3.78043L3.2475 1.81043L1.2775 3.78043C0.9875 4.07043 0.5075 4.07043 0.2175 3.78043C-0.0725 3.49043 -0.0725 3.01043 0.2175 2.72043L2.7175 0.22043C3.0075 -0.0695703 3.4875 -0.0695703 3.7775 0.22043L6.2775 2.72043C6.5675 3.01043 6.5675 3.49043 6.2775 3.78043C6.1275 3.93043 5.9375 4.00043 5.7475 4.00043Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.24756 15.5C2.83756 15.5 2.49756 15.16 2.49756 14.75V0.75C2.49756 0.34 2.83756 0 3.24756 0C3.65756 0 3.99756 0.34 3.99756 0.75V14.75C3.99756 15.16 3.65756 15.5 3.24756 15.5ZM11.2476 15.5C11.0576 15.5 10.8676 15.43 10.7176 15.28L8.21756 12.78C7.92756 12.49 7.92756 12.01 8.21756 11.72C8.50756 11.43 8.98756 11.43 9.27756 11.72L11.2476 13.69L13.2176 11.72C13.5076 11.43 13.9876 11.43 14.2776 11.72C14.5676 12.01 14.5676 12.49 14.2776 12.78L11.7776 15.28C11.6276 15.43 11.4376 15.5 11.2476 15.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2476 15.5C10.8376 15.5 10.4976 15.16 10.4976 14.75V0.75C10.4976 0.34 10.8376 0 11.2476 0C11.6576 0 11.9976 0.34 11.9976 0.75V14.75C11.9976 15.16 11.6576 15.5 11.2476 15.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.4605eb6e42ad23fc136369a817030681.svg";
export { ForwardRef as ReactComponent };